export { default } from "./tooltipContent";
